import './App.css';
import Spacer from "./components/Spacer/Spacer";
import Navbar from './components/0-Navbar/Navbar';
import PointsPrediction from "./pages/PointsPrediction/PointsPrediction";
import FAQ from "./pages/About/FAQ";
import Leaderboards from "./pages/Leaderboards/Leaderboards";

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  return (
      <Router>
          <Navbar/>
          <Spacer style={{padding: "30px"}}/>
          <Routes>
              <Route path="/" element={<PointsPrediction />} />
              <Route path="/prediction" element={<PointsPrediction />} />
              <Route path="/prediction/teams" element={<PointsPrediction />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/evaluation" element={<Leaderboards />} />
          </Routes>
      </Router>
  );
}

export default App;